
import api from '../libs/api';

export default {

  getEquipmentsRequest: (page, perPage, sortBy = '', sortOrder = '') => {
    return new Promise((resolve, reject) => {
      const queryParams = new URLSearchParams({
        page,
        perPage,
        sortBy,
        sortOrder,
      }).toString();
      
      api()
        .get(`/crf?${queryParams}`)
        .then(({ status, data }) => {
          if (status === 200) {
            resolve(data);
          } else {
            throw new Error(`Failed with status: ${status}`);
          }
        })
        .catch((error) => reject(error));
    });
  },



searchCrf: (fields, page = 1, perPage = 15, sortBy = '', sortOrder = '') => {
  return new Promise((resolve, reject) => {
      
      // .filter(([key, value]) => value !== undefined && value !== '' && typeof value !== 'object');

      const modifiedFields = { ...fields };

      if (
        fields.created_at_range &&
        fields.created_at_range.length === 2
      ) {
        modifiedFields.created_from =
          fields.created_at_range[0].format("YYYY-MM-DD");

        modifiedFields.created_to =
          fields.created_at_range[1].format("YYYY-MM-DD");

        delete modifiedFields.created_at_range;
      }

      const filteredFields = Object.entries(modifiedFields)
      .filter(([key, value]) => {
        if (key === "created_at_range") return true;

        return (
          value !== undefined &&
          value !== "" &&
          typeof value !== "object"
        );
      });
      
      const queryString = filteredFields
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');

      const paginationParams = new URLSearchParams({ page, perPage, sortBy, sortOrder }).toString();
      const url = `/crf-filters?${queryString}&${paginationParams}`;

      api()
          .get(url)
          .then(({ status, data }) => {
              if (status === 200) {
                  resolve(data);
              } else {
                  throw new Error(`Failed with status: ${status}`);
              }
          })
          .catch(error => reject(error));
  });
},

  postEquipmentRequest: (data) => {
    return new Promise((resolve, reject) => {
        api()
            .post(`/crf`, data)
            .then(({ status, data }) => {
                if (status === 201) resolve(data);
                throw new Error(`Failed with status: ${status}`);
            })
            .catch(error => reject(error));
    });
  },

  getEquipmentsRequestById: (id) => {
    return new Promise((resolve, reject) => {
        api()
            .get(`/crf/${id}`)
            .then(({ status, data }) => {
                if (status === 200) resolve(data.data);
                throw new Error(`Failed with status: ${status}`);
            })
            .catch(error => reject(error));
    });
  },

  
  updateEquipmentRequest: (id, data) => {
  return new Promise((resolve, reject) => {
      api()
          .put(`crf/${id}`, data)
          .then(({ status, data }) => {
              if (status === 201) resolve(data);
              throw new Error(`Failed with status: ${status}`);
          })
          .catch(error => reject(error));
  });
},

deleteCrf: (id) => {
  return new Promise((resolve, reject) => {
    api()
      .delete(`crf/${id}`)
      .then(({ status, data }) => {
        if (status === 200) {
          resolve(data);
        }
      })
      .catch(error => reject(error));
  });
},
  
getEmployeeByTitle: (search = "") => {
  return new Promise((resolve, reject) => {
    const queryParams = new URLSearchParams({
      search,
    }).toString();

    api()
      .get(`/search-employee-name?${queryParams}`)
      .then(({ status, data }) => {
        if (status === 200) {
          resolve(data);
        } else {
          throw new Error(`Failed with status: ${status}`);
        }
      })
      .catch((error) => reject(error));
  });
},

}